export const locations = [
    {
        city: 'Brasília',
        phone: '+ 55 61 3550-1385',
        adresses: 'Centro Empresarial Parque Brasília<br>Sig Quadra 1, Lote 985/1055 Sala 66<br>70610-410 Brasília - DF',
        maps: 'https://goo.gl/maps/ETi3YpwoEgYAJUsJ6',
        coordinates: {
            lat: -15.7750837,
            lon: -48.0772789,
        }
    },
    {
        city: 'Lago Sul',
        phone: '+ 55 61 3039-1645',
        adresses: 'SHI/SUL C.L QI - 09 Bloco "G"<br> Lojas 04, 05, 06 e 07 Ilha Bela, Lago Sul<br> 71625-070 Brasília - DF',
        maps: 'https://goo.gl/maps/quzEjcTtCUW3w4dJ8',
        coordinates: {
            lat: -15.7750837,
            lon: -48.0772789,
        }
    },
    /* {
        city: 'São Paulo',
        phone: '+ 55 11 4210-9616',
        adresses: 'Avenida Presidente Juscelino Kubitscheck,<br>n. 2041, torre B, 5º andar,<br>Vila Olímpia, São Paulo, SP, CEP 04.543-011',
        maps: 'https://goo.gl/maps/dMPb5yA5ZoXxeSaS6',
        coordinates: {
            lat: -23.6821604,
            lon: -46.875487,
        }
    }, */
    {
        city: 'Feira de Santana',
        phone: '+55 75 3023 0315',
        adresses: 'Av. João Durval Carneiro, 3665<br>Ed. Multiplace, Sala 311 - Caseb,<br>44051-900 Feira de Santana - BA',
        maps: '',
        coordinates: {
            lat: -8.0421584,
            lon: -35.0086757,
        }
    },
    /* {
        city: 'Fortaleza',
        phone: '+55 85 4042-0450',
        adresses: 'Rua Doutor Gilberto Studart, 55<br>Torre Norte, Entrada Sala 1517<br>Duets Office Towers<br>60192-105 Fortaleza - CE',
        maps: '',
        coordinates: {
            lat: -8.0421584,
            lon: -35.0086757,
        }
    }, */
    {
        city: 'Belém',
        phone: '',
        adresses: 'Travessa Dom Romualdo de Seixas,<br>nº 1560, Edifício Connext Office, Espaço Corporativo 05,<br>Bairro Umarizal, Belém, Pará, CEP 66.055-200',
        maps: '',
        coordinates: {
            lat: -8.05389,
            lon: -34.88111,
        }
    },
    {
        city: 'Recife',
        phone: '',
        adresses: 'Avenida Engenheiro Antônio de Góes,<br>nº 60, Edifício J, CPM Trade Center, sala 304,<br>Bairro de Pina, Recife, PE CEP 51.010-000',
        maps: '',
        coordinates: {
            lat: -8.05389,
            lon: -34.88111,
        }
    },
    {
        city: 'Aracaju',
        phone: '',
        adresses: 'Avenida Governador Paulo Barretode Menezes,<br>nº 2084 Bairro Farolandia, Aracaju - SE,<br> CEP 49.032-000',
        maps: '',
        coordinates: {
            lat: -10.91111,
            lon: -37.07167,
        }
    },
    {
        city: 'Salvador',
        phone: '',
        adresses: 'Avenida Tancredo Neves,<br>nº 620 23º andar – Salas 2301 à 2304<br>Caminho das Árvores, Salvador - BA, CEP 41.820-020',
        maps: '',
        coordinates: {
            lat: -10.91111,
            lon: -37.07167,
        }
    }
]
